import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function Footer() {
    return (
      <footer className="bg-gold py-3 mt-5">
        <div className="container text-center">
          <p className="text-white mb-0">Long Store | 2025</p>
        </div>
      </footer>
    );
  }
  
  export default Footer;